import { useContext, useEffect, useState } from "react";
import {
  Box,
  Container,
  Step,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { RegisterDetails } from "../../src/components/Registeration/RegisterDetails";
import theme from "../../src/styles/theme";
import Head from "next/head";
import {
  containerBackgroundWithMap,
  containerCard,
} from "../../src/styles/globalStyles";
import { LogoOnlyLayout } from "../../src/components/Layout";
import { Credentials } from "../../src/components/Credentials";
import { useRouter } from "next/router";
import { useUserData } from "../../src/hooks/useUserData";
import { LocalizationContext } from "../../src/lib/context";

export default function Register() {
  const { localeStrings } = useContext(LocalizationContext);
  const localizedPageContent = localeStrings.registerPage;
  const { user, userData, dronerModel } = useUserData();
  const [activeStep, setActiveStep] = useState(0);
  const router = useRouter();

  useEffect(() => {
    const manageSteps = () => {
      if (!!dronerModel?.username) {
        // after fully registered
        const pageAfterRegistration =
          "/" + router.locale + "/droners/" + dronerModel.username;
        return router.push(pageAfterRegistration).then(() => null);
      }
      if (!!dronerModel) {
        // after email + password / or social login
        return setActiveStep(2);
      }
      setActiveStep(0);
    };
    manageSteps();
  }, [dronerModel, router]);

  return (
    <Box
      sx={{
        ...containerBackgroundWithMap,
      }}
    >
      <Head>
        <title>{localizedPageContent.title}</title>
        <meta name="description" content={localizedPageContent.description} />
      </Head>
      <Container
        sx={{
          display: "flex",
          minHeight: { xs: 0, md: "100vh" },
          alignItems: "center",
          py: { xs: 10, md: 12 },
        }}
      >
        <Box
          sx={{
            ...containerCard,
            width: "100%",
          }}
        >
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={{ mt: 2, mb: 4, width: "100%" }}
          >
            {localizedPageContent.registerSteps.map(
              (step: { label: string }) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={step.label} {...stepProps}>
                    <StepLabel {...labelProps}>
                      {useMediaQuery(theme.breakpoints.up("sm"))
                        ? step.label
                        : null}
                    </StepLabel>
                  </Step>
                );
              }
            )}
          </Stepper>
          <Typography textAlign="center" variant="h3">
            {useMediaQuery(theme.breakpoints.down("sm"))
              ? localizedPageContent.registerSteps[activeStep].label
              : null}
          </Typography>

          <Box
            sx={{
              minHeight: 300,
              pt: 4,
              width: "100%",
            }}
          >
            {activeStep === 0 && (
              <Credentials localizedPageContent={localizedPageContent} />
            )}
            {activeStep === 2 && (
              <RegisterDetails
                existing={false}
                user={user}
                userData={userData}
              />
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

Register.Layout = LogoOnlyLayout;
